import React, { useEffect, useState } from 'react';
import { BarChart3, RefreshCw, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BAR_COLORS = ['#1de9d0', '#22d3ee', '#a78bfa', '#f472b6', '#fbbf24'];

export default function PollsTab({ token }) {
  const [polls, setPolls] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/admin/polls`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setPolls(data.polls || []);
      }
    } catch (e) {
      console.error('polls load error', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [token]);

  return (
    <div className="space-y-4 md:space-y-6" data-testid="admin-polls-tab">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h3 className="text-white font-semibold text-base md:text-lg flex items-center gap-2">
            <BarChart3 className="w-5 h-5 text-cyan-400" /> Sondages
          </h3>
          <p className="text-gray-500 text-xs md:text-sm mt-0.5">
            Résultats « Comment as-tu connu AqmOpti ? » — privé, les membres ne voient rien. Lance-le avec <code className="text-cyan-400">/sondage</code> sur Discord.
          </p>
        </div>
        <button
          onClick={load}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-gray-300 text-sm"
          data-testid="polls-refresh-btn"
        >
          <RefreshCw className="w-4 h-4" /> Actualiser
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-16 text-gray-500">
          <Loader2 className="w-6 h-6 animate-spin" />
        </div>
      ) : polls.length === 0 ? (
        <div className="text-center py-16 text-gray-500 bg-zinc-900/50 border border-zinc-800 rounded-xl">
          Aucun sondage pour l'instant. Tape <code className="text-cyan-400">/sondage</code> dans un salon Discord pour en lancer un.
        </div>
      ) : (
        polls.map((poll) => (
          <div key={poll.id} className="bg-zinc-900/50 border border-cyan-900/30 rounded-xl p-4 md:p-5" data-testid={`poll-card-${poll.id}`}>
            <div className="flex items-start justify-between gap-3 mb-4 flex-wrap">
              <div>
                <p className="text-white font-semibold text-sm md:text-base">{poll.question}</p>
                <p className="text-[11px] text-gray-500 mt-0.5">
                  {poll.created_at ? new Date(poll.created_at).toLocaleString('fr-FR') : ''}
                  {poll.active ? ' · actif' : ' · clôturé'}
                </p>
              </div>
              <span className="text-[11px] px-2.5 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-cyan-300 font-semibold whitespace-nowrap">
                {poll.total} vote{poll.total > 1 ? 's' : ''}
              </span>
            </div>

            <div className="space-y-3">
              {poll.options.map((opt, i) => {
                const pct = poll.total > 0 ? (opt.count / poll.total) * 100 : 0;
                return (
                  <div key={opt.key} data-testid={`poll-option-${opt.key}`}>
                    <div className="flex items-center justify-between text-xs md:text-sm mb-1">
                      <span className="text-gray-300">{opt.emoji} {opt.label}</span>
                      <span className="text-gray-400 font-medium tabular-nums">{opt.count} ({pct.toFixed(0)}%)</span>
                    </div>
                    <div className="h-2.5 rounded-full bg-zinc-800 overflow-hidden">
                      <div
                        className="h-full rounded-full transition-all duration-500"
                        style={{ width: `${pct}%`, backgroundColor: BAR_COLORS[i % BAR_COLORS.length] }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
